import { Maximize2 } from 'lucide-react';
import { useGallery } from '../../hooks/useGallery';
import { Dialog, DialogTrigger } from '../ui/dialog';
import { GalleryThumbnails } from './GalleryThumbnails';
import { GalleryLightbox } from './GalleryLightbox';

export const DetailGallery = ({ kind, title, images, icon: Icon }) => {
  const gallery = useGallery(images);
  if (!gallery.count) return null;
  return (
    <Dialog open={gallery.open} onOpenChange={gallery.setOpen}>
      <div className="relative min-w-0">
        <DialogTrigger asChild>
          <button type="button" data-testid={`${kind}-gallery-open-button`} aria-label="Buyut" className="relative w-full aspect-[4/3] overflow-hidden rounded-2xl border border-white/5 shadow-2xl group block">
            <img key={gallery.image} data-testid={`${kind}-gallery-image`} src={gallery.image} alt={title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
            <span className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
            <span data-testid={`${kind}-gallery-count`} className="absolute top-4 right-4 px-3 py-1.5 rounded-full bg-background/80 backdrop-blur-md border border-white/15 text-[11px] text-white/90 font-medium tracking-wide">
              {gallery.activeIndex + 1} / {gallery.count}
            </span>
            {Icon && <span className="absolute top-4 left-4 w-11 h-11 rounded-2xl bg-background/80 backdrop-blur-md border border-primary/40 flex items-center justify-center"><Icon size={20} strokeWidth={1.6} className="text-accent" /></span>}
            <span className="absolute bottom-4 right-4 w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300"><Maximize2 size={16} /></span>
          </button>
        </DialogTrigger>
        <GalleryThumbnails images={images} title={title} kind={kind} {...gallery} />
      </div>
      <GalleryLightbox kind={kind} title={title} gallery={gallery} />
    </Dialog>
  );
};